module.exports = __webpack_public_path__ + "static/media/CB.ff624a28.png";